(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-subnav"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function bindRail(rail) {
      if (rail.dataset.csubInit) return;
      var track = rail.querySelector('[data-csub-track]');
      if (!track) return;
      rail.dataset.csubInit = '1';

      var down = false, moved = false, startX = 0, startScroll = 0;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        down = true; moved = false;
        startX = e.clientX; startScroll = track.scrollLeft;
        track.classList.add('is-grabbing');
      });
      document.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 4) moved = true;
        track.scrollLeft = startScroll - dx;
      });
      function end() { if (!down) return; down = false; track.classList.remove('is-grabbing'); }
      document.addEventListener('pointerup', end);
      document.addEventListener('pointercancel', end);
      track.addEventListener('click', function (e) {
        if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
      }, true);

      function updateState() {
        var max = track.scrollWidth - track.clientWidth;
        rail.classList.toggle('is-start', track.scrollLeft <= 2);
        rail.classList.toggle('is-end', max <= 0 || track.scrollLeft >= max - 2);
      }
      track.addEventListener('scroll', updateState, { passive: true });
      window.addEventListener('resize', updateState);
      updateState();
    }

    function init(root) {
      var scope = root || document;
      var r = scope.querySelectorAll('[data-csub-rail]');
      for (var j = 0; j < r.length; j++) bindRail(r[j]);
    }

    if (document.readyState !== 'loading') init(document);
    else document.addEventListener('DOMContentLoaded', function () { init(document); });
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  // Return-to-card scroll (owner, 29.08). The ticket lives in sessionStorage
  // (product-card.js writes it at click time) — the address bar is NEVER touched.
  // Consumed once, and only on a real history return (navigation.type = back_forward):
  // a menu-link visit or a reload finds no valid ticket and stays where the shopper
  // left the page. When the "load more" list puts its saved view back after a reload or
  // Back (snippets/r69-list-restore.liquid), it drops the ticket first: that view is exact,
  // and scrollIntoView here would move it.
  const RETURN_KEY = 'r69:return:' + window.location.pathname;
  const takeTicket = () => {
    let ticket = null;
    try {
      ticket = JSON.parse(sessionStorage.getItem(RETURN_KEY) || 'null');
      sessionStorage.removeItem(RETURN_KEY);
    } catch (error) {
      // storage blocked — nothing to consume
    }
    return ticket && ticket.id ? ticket.id : null;
  };
  document.addEventListener(
    'DOMContentLoaded',
    () => {
      const nav = performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null;
      const ticketId = takeTicket();
      if (nav && nav.type === 'back_forward' && ticketId) {
        const card = document.getElementById(ticketId);
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      }
    },
    { once: true }
  );
  // bfcache return: DOMContentLoaded is skipped and the browser restores scroll itself —
  // burn the ticket, or a later reload could act on it.
  window.addEventListener('pageshow', () => {
    try {
      sessionStorage.removeItem(RETURN_KEY);
    } catch (error) {
      /* storage blocked */
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["r69-wishlist"]) return;
  try {
    
  (function () {
    /* Cards are fetched in batches instead of being resolved in Liquid: `all_products` is capped at
       20 lookups per page render, which silently truncated any longer wishlist. Each batch is one
       Section Rendering request for the next N saved ids, so the list can be as long as the shopper
       wants. Skeletons hold the first batch's space until it lands. */
    function host() { return document.querySelector('.wishlist-list'); }
    function grid() { return document.querySelector('.wishlist-list .product-grid'); }
    function control() { return document.querySelector('.wishlist-list [data-r69lm-next-wrap]'); }
    function store() { return (window.R69 && window.R69.wishlistStore) || null; }

    function per() {
      var h = host();
      var n = h ? parseInt(h.getAttribute('data-per-page'), 10) : 0;
      return n > 0 ? n : 24;
    }
    /* What this batch has to render. Normally the shopper's own saved products, by id, from the
       store. On a SHARED view <wishlist-list> puts the sharer's handles on data-render-handles, and those are queried
       by handle: — the viewer's own ids would be the wrong list entirely. */
    function targets() {
      var h = host();
      var shared = h ? (h.getAttribute('data-render-handles') || '') : '';
      if (shared) {
        return shared.split(',').map(function (x) { return x.trim(); }).filter(Boolean)
          .map(function (v) { return { type: 'handle', value: v }; });
      }
      var s = store();
      if (!s) return [];
      return s.items.map(function (i) { return String(i.id); }).filter(Boolean)
        .map(function (v) { return { type: 'id', value: v }; });
    }
    function savedVariants() {
      var h = host(), m = {};
      if (h && h.getAttribute('data-render-handles')) {
        try { m = JSON.parse(h.getAttribute('data-render-variants') || '{}') || {}; } catch (e) { m = {}; }
        return m;
      }
      var s = store();
      if (s) s.items.forEach(function (i) { if (i.variantId) m[String(i.id)] = String(i.variantId); });
      return m;
    }
    function paintSaved(cards) {
      var m = savedVariants();
      cards.forEach(function (card) {
        var vid = m[card.getAttribute('data-product-id')];
        if (!vid || vid === card.getAttribute('data-default-variant-id')) return;
        var data = null;
        try { data = JSON.parse(card.getAttribute('data-variants') || 'null'); } catch (e) { data = null; }
        var d = data && data[vid];
        if (!d) return;
        card.setAttribute('data-saved-variant-id', vid);
        var img = card.querySelector('.product-media img, slideshow-slide img, img');
        if (img && d[0]) { img.srcset = d[0]; img.src = d[0]; }
        var price = card.querySelector('product-price .price__regular .price, product-price .price, .price');
        if (price && d[1]) price.textContent = d[1];
      });
    }
    function selectSaved(cards) {
      requestAnimationFrame(function () {
        cards.forEach(function (card) {
          var vid = card.getAttribute('data-saved-variant-id');
          if (!vid) return;
          var input = card.querySelector('input[type="radio"][data-variant-id="' + CSS.escape(vid) + '"]');
          if (input && !input.checked) {
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      });
    }
    function isSharedView() {
      var p = new URLSearchParams(location.search);
      return !!(p.get('share') || p.get('w'));
    }

    var loaded = 0, busy = false;

    function updateControl(total) {
      var wrap = control(); if (!wrap) return;
      /* The count only earns its place while there is something left to load — once everything is
         on screen it just repeats the saved total already shown in the header. */
      wrap.hidden = total <= 0 || loaded >= total;

      var count = wrap.querySelector('[data-r69lm-count]');
      if (count) {
        var tpl = count.getAttribute('data-template') || '%loaded% / %total%';
        count.textContent = tpl.replace('%loaded%', loaded).replace('%total%', total);
      }
      var fill = wrap.querySelector('[data-r69lm-fill]');
      if (fill) fill.style.width = (total ? Math.min(100, (loaded / total) * 100) : 0) + '%';

      var btn = wrap.querySelector('[data-r69lm-next]');
      if (btn) {
        btn.hidden = loaded >= total;
        btn.disabled = busy;
        btn.classList.toggle('is-loading', busy);
      }
    }

    function dropSkeletons() {
      var g = grid(); if (!g) return;
      var skels = g.querySelectorAll('[data-wl-skel]');
      for (var i = 0; i < skels.length; i++) skels[i].remove();
    }

    function fetchBatch() {
      var h = host(), g = grid();
      if (!h || !g || busy) return;
      var list = targets();
      var slice = list.slice(loaded, loaded + per());
      /* Nothing left to fetch — the skeletons the server reserved space with must still go, or
         they sit there forever pretending the cards are on their way. */
      if (!slice.length) { dropSkeletons(); updateControl(list.length); return; }

      busy = true;
      updateControl(list.length);

      var q = slice.map(function (t) { return t.type + ':' + t.value; }).join(' OR ');
      /* unavailable_products=show: a wishlist must keep showing what the shopper saved even
         when it sells out (and regardless of the Search & Discovery search default). */
      var url = h.getAttribute('data-url') + '?q=' + encodeURIComponent(q) +
        '&type=product&options%5Bunavailable_products%5D=show&section_id=' + h.getAttribute('data-section');

      fetch(url)
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          busy = false;
          if (!html) { dropSkeletons(); updateControl(list.length); return; }

          var doc = new DOMParser().parseFromString(html, 'text/html');
          var byId = {}, byHandle = {};
          doc.querySelectorAll('[data-wishlist-card]').forEach(function (card) {
            byId[card.getAttribute('data-product-id')] = card;
            byHandle[card.getAttribute('data-product-handle')] = card;
          });

          /* search answers by relevance — put the batch back in the shopper's saved order */
          var frag = document.createDocumentFragment();
          var cards = [];
          slice.forEach(function (t) {
            var card = t.type === 'id' ? byId[t.value] : byHandle[t.value];
            if (card) cards.push(document.importNode(card, true));
          });
          paintSaved(cards);
          cards.forEach(function (card) { frag.appendChild(card); });

          dropSkeletons();
          g.appendChild(frag);
          selectSaved(cards);
          var s = store();
          if (s && s.rewriteHandles && !h.getAttribute('data-render-handles')) {
            var map = {};
            cards.forEach(function (card) { map[card.getAttribute('data-product-id')] = card.getAttribute('data-product-handle'); });
            s.rewriteHandles(map, { quiet: true });
          }
          /* Count the slice, not what came back: a product that was unpublished since it was saved
             returns nothing, and skipping it would wedge the button on the same batch forever. */
          loaded += slice.length;
          updateControl(list.length);
        })
        .catch(function () { busy = false; dropSkeletons(); updateControl(targets().length); });
    }

    function init() {
      var h = host(); if (!h) return;
      var wrap = control();
      if (wrap) {
        var btn = wrap.querySelector('[data-r69lm-next]');
        if (btn && !btn.dataset.bound) {
          btn.dataset.bound = '1';
          btn.addEventListener('click', fetchBatch);
        }
      }
      /* A shared view still shows the VIEWER's own server-rendered markup at this point.
         <wishlist-list> is fetching the sharer's list; wait for it rather than flash our own. */
      if (isSharedView() && !(h.getAttribute('data-render-handles') || '')) return;
      fetchBatch();
    }

    /* <wishlist-list> rebuilds the skeletons on every wishlist:change (and once for a shared
       list), so the loader starts over on the new ones. */
    document.addEventListener('wishlist:rendered', function () {
      loaded = 0;
      busy = false;
      init();
    });

    /* Wait for BOTH: the section markup (this bundle can run before the body is parsed, and init
       would then find no host and give up silently) and the store, which hydrates from the app
       proxy / cart. */
    var tries = 0;
    (function ready() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', ready, { once: true });
        return;
      }
      if (store() || tries > 80) { init(); return; }
      tries++; setTimeout(ready, 50);
    })();
  })();

  /* ---- Wishlist sharing: short revocable code links (backend) with an in-URL fallback ---- */
  (function () {
    var I = { copy: 'Copy link', copied: 'Copied!', createLink: 'Create link', createPlaceholder: '', savedCount: '[n]' };
    try {
      var raw = document.querySelector('[data-wl-i18n]');
      if (raw) I = Object.assign(I, JSON.parse(raw.textContent));
    } catch (e) { /* keep defaults */ }

    function store() { return (window.R69 && window.R69.wishlistStore) || null; }
    function share() { return (window.R69 && window.R69.wishlistShare) || null; }
    function items() { var s = store(); return s ? s.items : []; }
    function shareEl() { return document.querySelector('[data-wl-share]'); }
    function pageBase() { return location.origin + location.pathname.split('?')[0]; }
    function hasApi() { var sh = share(); return !!(sh && sh.enabled()); }
    function isOn() { var sh = share(); return !!(sh && sh.isOn()); }

    function handlesFromCards() {
      return Array.prototype.slice.call(document.querySelectorAll('.wishlist-list [data-wishlist-card]'))
        .map(function (c) { return c.getAttribute('data-product-handle'); }).filter(Boolean);
    }
    function fallbackUrl() {
      var hs = items().map(function (i) { return i.handle; }).filter(Boolean);
      if (!hs.length) hs = handlesFromCards();
      var val = hs.join(',');
      return pageBase() + (val ? ('?w=' + encodeURIComponent(val)) : '');
    }
    // The link shown / copied / shared: with the backend, the code link when on (else '' when off);
    // without a backend, the in-URL handles link.
    function currentUrl() {
      if (hasApi()) { var sh = share(); return sh.isOn() ? sh.currentLink() : ''; }
      return fallbackUrl();
    }

    function isShared() { var p = new URLSearchParams(location.search); return !!(p.get('share') || p.get('w')); }
    function shareText() { var el = shareEl(); return (el && el.getAttribute('data-share-text')) || document.title; }
    function cardCount() { return document.querySelectorAll('.wishlist-list [data-wishlist-card]').length; }
    function currentCount() { var s = store(); return s ? s.count : cardCount(); }
    function copyBtn() { return document.querySelector('[data-wl-share-net="copy"]'); }

    // Reflect the on/off state into the field, Copy label, and manage row.
    function paintState() {
      var inp = document.querySelector('[data-wl-url]');
      var manage = document.querySelector('[data-wl-manage]');
      var b = copyBtn(); var lbl = b ? b.querySelector('[data-wl-copy-text]') : null;
      var off = hasApi() && !isOn();
      if (inp) {
        if (off) { inp.value = ''; inp.placeholder = I.createPlaceholder; }
        else { inp.value = currentUrl(); inp.placeholder = ''; }
      }
      if (lbl && !(b && b.classList.contains('is-copied'))) lbl.textContent = off ? I.createLink : I.copy;
      if (manage) manage.hidden = !(hasApi() && isOn());
    }

    function refreshState(n) {
      if (typeof n !== 'number') n = currentCount();
      var c = document.querySelector('[data-wl-count]');
      var sh = shareEl();
      // Viewing someone else's shared list: hide the owner controls (count + share bar).
      if (isShared()) { if (c) c.hidden = true; if (sh) sh.hidden = true; return; }
      if (c) { if (n > 0) { c.textContent = I.savedCount.replace('[n]', n); c.hidden = false; } else c.hidden = true; }
      if (sh) sh.hidden = n === 0;
      paintState();
    }

    function fallbackCopy(url) {
      try {
        var t = document.createElement('textarea');
        t.value = url; t.style.position = 'fixed'; t.style.opacity = '0';
        document.body.appendChild(t); t.select(); document.execCommand('copy'); document.body.removeChild(t);
      } catch (e) { /* ignore */ }
    }
    function writeClip(url) {
      if (navigator.clipboard && navigator.clipboard.writeText) return navigator.clipboard.writeText(url).catch(function () { fallbackCopy(url); });
      fallbackCopy(url); return Promise.resolve();
    }
    function flashCopied() {
      var b = copyBtn(); if (!b) return;
      var lbl = b.querySelector('[data-wl-copy-text]');
      b.classList.add('is-copied'); if (lbl) lbl.textContent = I.copied;
      setTimeout(function () { b.classList.remove('is-copied'); paintState(); }, 1800);
    }

    // Ensure a link exists (mint one on the backend if needed), then return it.
    function ensureLink() {
      if (!hasApi()) return Promise.resolve(fallbackUrl());
      var sh = share();
      if (sh.isOn()) return Promise.resolve(sh.currentLink());
      return sh.create().then(function () { paintState(); return sh.currentLink(); });
    }

    function onCopy() { ensureLink().then(function (url) { if (url) writeClip(url).then(flashCopied); }); }
    function openShare(net) {
      ensureLink().then(function (url) {
        if (!url) return;
        var t = shareText(), u = encodeURIComponent(url), tx = encodeURIComponent(t);
        if (net === 'email') { location.href = 'mailto:?subject=' + tx + '&body=' + encodeURIComponent(t + '\n\n' + url); return; }
        var map = {
          whatsapp: 'https://wa.me/?text=' + encodeURIComponent(t + ' ' + url),
          telegram: 'https://t.me/share/url?url=' + u + '&text=' + tx,
          facebook: 'https://www.facebook.com/sharer/sharer.php?u=' + u,
          x: 'https://twitter.com/intent/tweet?url=' + u + '&text=' + tx
        };
        if (map[net]) window.open(map[net], '_blank', 'noopener,width=620,height=560');
      });
    }
    function nativeShare() {
      if (!navigator.share) return;
      ensureLink().then(function (url) { if (url) navigator.share({ title: shareText(), text: shareText(), url: url }).catch(function () {}); });
    }
    function rotate() { var sh = share(); if (sh) sh.rotate().then(paintState); }
    function disable() { var sh = share(); if (sh) sh.disable().then(paintState); }

    function wireShare() {
      var sh = shareEl(); if (!sh) return;
      var nativeBtn = sh.querySelector('[data-wl-share-net="native"]');
      if (nativeBtn && navigator.share) nativeBtn.hidden = false;
      sh.addEventListener('click', function (e) {
        if (e.target.closest('[data-wl-share-rotate]')) { rotate(); return; }
        if (e.target.closest('[data-wl-share-disable]')) { disable(); return; }
        var b = e.target.closest('[data-wl-share-net]'); if (!b) return;
        var net = b.getAttribute('data-wl-share-net');
        if (net === 'copy') onCopy();
        else if (net === 'native') nativeShare();
        else openShare(net);
      });
    }

    function start() {
      wireShare();
      refreshState();
      // Recover the on/off state from the server once (survives reloads), then repaint.
      if (hasApi() && share().refresh) share().refresh().then(paintState);
      document.addEventListener('wishlist:change', function (e) {
        refreshState(e.detail && typeof e.detail.count === 'number' ? e.detail.count : undefined);
      });
      var host = document.querySelector('.wishlist-list');
      if (host && window.MutationObserver) {
        var t; new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { refreshState(); }, 120); }).observe(host, { childList: true, subtree: true });
      }
    }

    // Wait for the wishlist module (store + share helpers) to be present, then start.
    var tries = 0;
    (function ready() {
      if ((window.R69 && window.R69.wishlistShare) || tries > 80) { start(); return; }
      tries++; setTimeout(ready, 50);
    })();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rotas69-care"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-r69care]');
    if (!root || root.dataset.r69careInit) return;
    root.dataset.r69careInit = '1';
    var nav = root.querySelector('[data-care-nav]');
    var links = nav ? nav.querySelectorAll('a') : [];
    var sections = root.querySelectorAll('[data-care-section]');
    if ('IntersectionObserver' in window) {
      var spy = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            var id = e.target.getAttribute('id');
            links.forEach(function (l) { l.classList.toggle('is-active', l.getAttribute('href') === '#' + id); });
          }
        });
      }, { rootMargin: '-45% 0px -50% 0px' });
      sections.forEach(function (sec) { spy.observe(sec); });
    }
    links.forEach(function (l) {
      l.addEventListener('click', function (ev) {
        var target = root.querySelector(l.getAttribute('href'));
        if (target) { ev.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rotas69-contact"]) return;
  try {
    
  // After a form POST the page reloads — bring the success/error note into
  // view instead of leaving the visitor at the top wondering what happened.
  (function () {
    var note = document.querySelector('[data-r69con-note]');
    if (!note) return;
    note.scrollIntoView({ block: 'center', behavior: 'instant' });
    note.focus({ preventScroll: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rotas69-faq"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-r69faq]');
    if (!root || root.dataset.r69faqInit) return;
    root.dataset.r69faqInit = '1';

    var content = root.querySelector('[data-r69faq-content]');
    var nav = root.querySelector('[data-r69faq-nav]');
    var noResults = root.querySelector('[data-r69faq-noresults]');

    // Wrap each <h2> and its following rows into a group, and build the
    // sidebar from the headings — the page body stays plain authorable HTML.
    var groups = [];
    var nodes = Array.prototype.slice.call(content.children);
    var current = null;
    nodes.forEach(function (node) {
      if (node.hasAttribute && node.hasAttribute('data-r69faq-noresults')) return;
      if (node.tagName === 'H2') {
        current = document.createElement('div');
        current.className = 'r69faq__group';
        content.insertBefore(current, node);
        current.appendChild(node);
        groups.push(current);
      } else if (current) {
        current.appendChild(node);
      }
    });

    var links = [];
    groups.forEach(function (group) {
      var h2 = group.querySelector('h2');
      if (!h2 || !h2.id) return;
      var a = document.createElement('a');
      a.href = '#' + h2.id;
      a.textContent = h2.textContent;
      a.setAttribute('data-r69faq-navlink', h2.id);
      nav.appendChild(a);
      links.push(a);
    });

    // Live search: filter rows, open matches, hide empty groups.
    var search = root.querySelector('[data-r69faq-search]');
    var items = content.querySelectorAll('details');
    // The answer <div> of each row gets a class, so the open-state fade-in rule can be keyed on it
    // instead of `details[open] > div`: a bare tag subject under `[open]` made Blink check every
    // <div> inside any element whose `open` changed, site-wide (closing the filters drawer restyled
    // 389 of its elements; audit/2026-09/invalidation-rule-bisect-2026-09-06.mjs, 06.09.2026).
    items.forEach(function (item) {
      for (var child = item.firstElementChild; child; child = child.nextElementSibling) {
        if (child.tagName === 'DIV') child.classList.add('r69faq__answer');
      }
    });
    if (search) {
      search.addEventListener('input', function () {
        var q = search.value.trim().toLowerCase();
        var any = false;
        items.forEach(function (item) {
          var match = !q || item.textContent.toLowerCase().indexOf(q) !== -1;
          item.hidden = !match;
          if (match) any = true;
          item.open = q ? match : false;
        });
        groups.forEach(function (group) {
          group.hidden = !!q && !group.querySelector('details:not([hidden])');
        });
        if (noResults) noResults.hidden = any;
      });
    }

    // Scrollspy for the sidebar.
    if ('IntersectionObserver' in window && links.length) {
      var byId = {};
      links.forEach(function (l) { byId[l.getAttribute('data-r69faq-navlink')] = l; });
      var spy = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            links.forEach(function (l) { l.classList.remove('is-active'); });
            var h2 = e.target.querySelector('h2');
            var link = h2 && byId[h2.id];
            if (link) link.classList.add('is-active');
          }
        });
      }, { rootMargin: '-15% 0px -75% 0px' });
      groups.forEach(function (g) { spy.observe(g); });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rotas69-size-guide"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-r69sg]');
    if (!root || root.dataset.r69sgInit) return;
    root.dataset.r69sgInit = '1';
    var PI = Math.PI;

    /* size maths: a ROTAS69 size IS the inside diameter in mm */
    function usToDia(us) { return 11.63 + 0.8128 * us; }
    function diaToUs(d) { return (d - 11.63) / 0.8128; }
    var letters = ['F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
    var UK_BASE = 14.11, UK_STEP = 0.4;
    function ukLetterToDia(raw) {
      var str = String(raw).toUpperCase().replace(/\s/g, '');
      var plus = str.indexOf('+') > -1 ? (parseFloat(str.split('+')[1]) || 0) : 0;
      var half = str.indexOf('½') > -1 || str.indexOf('.5') > -1;
      var i = letters.indexOf(str.charAt(0));
      if (i < 0) return null;
      return UK_BASE + UK_STEP * (i + plus + (half ? 0.5 : 0));
    }
    function diaToUk(d) {
      var idx = (d - UK_BASE) / UK_STEP;
      if (idx < 0) idx = 0;
      var base = Math.floor(idx), rem = idx - base, last = letters.length - 1;
      if (base >= last) {
        var over = Math.round((idx - last) * 2) / 2;
        return over > 0 ? 'Z+' + over : 'Z';
      }
      if (rem < 0.25) return letters[base];
      if (rem < 0.75) return letters[base] + '½';
      return letters[base + 1];
    }
    function fmt(n, dp) { return (Math.round(n * Math.pow(10, dp)) / Math.pow(10, dp)).toFixed(dp); }
    /* coalesce rapid slider input into one update per frame — fast drags
       fire dozens of events and jitter without this */
    function onFrame(fn) {
      var scheduled = false;
      return function () {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(function () { scheduled = false; fn(); });
      };
    }

    /* 1. Ring converter */
    (function () {
      var wrap = root.querySelector('[data-sg-converter]');
      if (!wrap) return;
      var mode = wrap.querySelector('[data-conv-mode]');
      var value = wrap.querySelector('[data-conv-value]');
      var vlabel = wrap.querySelector('[data-conv-vlabel]');
      var out = wrap.querySelector('[data-conv-out]');
      var hint = wrap.querySelector('[data-conv-hint]');
      var oSize = wrap.querySelector('[data-out-size]'), oEu = wrap.querySelector('[data-out-eu]'),
          oUs = wrap.querySelector('[data-out-us]'), oUk = wrap.querySelector('[data-out-uk]'),
          oCirc = wrap.querySelector('[data-out-circ]');
      var rows = root.querySelectorAll('[data-ring-table] tbody tr');
      var placeholders = { dia: '16.9', circ: '53,1', eu: '53', us: '6.5', uk: 'M' };
      var defaultHint = hint.textContent;
      var labelTexts = {};
      mode.querySelectorAll('option').forEach(function (o) { labelTexts[o.value] = o.textContent; });

      function highlight(dia) {
        var best = null, bestD = 1e9;
        rows.forEach(function (r) {
          var diff = Math.abs(parseFloat(r.getAttribute('data-dia')) - dia);
          if (diff < bestD) { bestD = diff; best = r; }
        });
        rows.forEach(function (r) { r.classList.toggle('is-match', r === best); });
      }
      function clearHighlight() { rows.forEach(function (r) { r.classList.remove('is-match'); }); }
      function fail(msg) {
        out.hidden = true;
        hint.textContent = msg;
        hint.classList.add('is-error');
        clearHighlight();
      }

      function compute() {
        var m = mode.value;
        var raw = value.value.trim();
        if (raw === '') { out.hidden = true; hint.textContent = defaultHint; hint.classList.remove('is-error'); clearHighlight(); return; }
        var dia = null;
        if (m === 'uk') {
          dia = ukLetterToDia(raw);
          if (dia === null) return fail(root.dataset.errUk);
        } else {
          var num = parseFloat(raw.replace(',', '.'));
          if (isNaN(num)) return fail(root.dataset.errNum);
          if (m === 'us') dia = usToDia(num);
          else if (m === 'eu' || m === 'circ') dia = num / PI;
          else dia = num;
        }
        if (dia < 14 || dia > 24.5) return fail(root.dataset.errRange);
        hint.classList.remove('is-error');
        hint.textContent = defaultHint;
        var circ = dia * PI;
        oSize.textContent = fmt(dia, 1) + ' ' + (root.dataset.unitMm || 'mm');
        oEu.textContent = Math.round(circ).toString();
        oUs.textContent = (Math.round(diaToUs(dia) * 4) / 4).toString();
        oUk.textContent = diaToUk(dia);
        oCirc.textContent = fmt(circ, 1);
        out.hidden = false;
        highlight(dia);
      }

      mode.addEventListener('change', function () {
        vlabel.textContent = labelTexts[mode.value];
        value.setAttribute('placeholder', placeholders[mode.value]);
        value.setAttribute('inputmode', mode.value === 'uk' ? 'text' : 'decimal');
        compute();
      });
      value.addEventListener('input', compute);
    })();

    /* 2. On-screen sizer with bank-card calibration */
    (function () {
      var wrap = root.querySelector('[data-sg-screen]');
      if (!wrap) return;
      var calib = wrap.querySelector('[data-calib]');
      var autoNote = wrap.querySelector('[data-auto-note]');
      var stepLabel = wrap.querySelector('[data-step-label]');
      var cardRect = wrap.querySelector('[data-card-rect]');
      var cardRange = wrap.querySelector('[data-card-range]');
      var ringCircle = wrap.querySelector('[data-ring-circle]');
      var ringRange = wrap.querySelector('[data-ring-range]');
      var rDia = wrap.querySelector('[data-ring-dia]');
      var rEu = wrap.querySelector('[data-ring-eu]');
      var rUs = wrap.querySelector('[data-ring-us]');
      var rUk = wrap.querySelector('[data-ring-uk]');
      var CARD_MM = 85.6;
      var isMobile = window.matchMedia('(max-width: 749px)').matches;

      function autoPxPerMm() { return (isMobile ? 150 : 96) / 25.4; }
      var pxPerMm = autoPxPerMm();

      function setFromCard() {
        var px = parseFloat(cardRange.value);
        if (cardRect) cardRect.style.width = px + 'px';
        pxPerMm = px / CARD_MM;
        drawRing();
      }
      function drawRing() {
        var dia = parseFloat(ringRange.value);
        ringCircle.style.width = (dia * pxPerMm) + 'px';
        ringCircle.style.height = (dia * pxPerMm) + 'px';
        rDia.textContent = fmt(dia, 1) + ' ' + (root.dataset.unitMm || 'mm');
        rEu.textContent = Math.round(dia * PI).toString();
        rUs.textContent = (Math.round(diaToUs(dia) * 4) / 4).toString();
        rUk.textContent = diaToUk(dia);
      }

      if (isMobile) {
        /* phones: a bank card cannot fit on the screen, so there is no card
           calibration at all — the scale is estimated automatically */
        if (autoNote) autoNote.hidden = false;
      } else {
        if (calib) calib.hidden = false;
        if (stepLabel && root.dataset.step2Desktop) stepLabel.textContent = root.dataset.step2Desktop;
        if (cardRange) cardRange.addEventListener('input', onFrame(setFromCard));
        setFromCard();
      }
      ringRange.addEventListener('input', onFrame(drawRing));
      drawRing();

      /* PHONE touchscreens only: a ring lying on the glass scrolls the page —
         a clear lock button freezes the screen while measuring (the slider
         stays live). Desktops never see it. */
      var lockBtn = wrap.querySelector('[data-screen-lock]');
      var isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
      if (lockBtn && isMobile && isTouch) {
        lockBtn.hidden = false;
        var locked = false;
        var blockTouch = function (e) {
          if (e.target === ringRange) return;
          e.preventDefault();
        };
        lockBtn.addEventListener('click', function () {
          locked = !locked;
          lockBtn.textContent = locked ? lockBtn.dataset.unlockLabel : lockBtn.dataset.lockLabel;
          lockBtn.setAttribute('aria-pressed', locked ? 'true' : 'false');
          lockBtn.classList.toggle('is-locked', locked);
          document.documentElement.classList.toggle('r69sg-locked', locked);
          if (locked) document.addEventListener('touchmove', blockTouch, { passive: false });
          else document.removeEventListener('touchmove', blockTouch);
        });
      }
    })();

    /* 3. Necklace visualiser: the first length starts selected, hover
       previews, a click locks the choice until another one is clicked */
    (function () {
      var list = root.querySelector('[data-neck-list]');
      var lines = root.querySelector('[data-neck-lines]');
      if (!list || !lines) return;
      var locked = '40';
      function setOn(len) {
        list.querySelectorAll('li').forEach(function (li) { li.classList.toggle('is-on', li.getAttribute('data-len') === len); });
        lines.querySelectorAll('.r69sg__drape').forEach(function (p) { p.classList.toggle('is-on', p.getAttribute('data-len') === len); });
      }
      list.querySelectorAll('li').forEach(function (li) {
        var len = li.getAttribute('data-len');
        li.setAttribute('tabindex', '0');
        li.addEventListener('mouseenter', function () { setOn(len); });
        li.addEventListener('focus', function () { setOn(len); });
        li.addEventListener('click', function () { locked = len; setOn(len); });
      });
      list.addEventListener('mouseleave', function () { setOn(locked); });
      setOn(locked);
    })();

    /* 4. Wrist → bracelet length: suggest bar + the always-visible cards light up */
    (function () {
      var wrap = root.querySelector('[data-sg-bracelet]');
      if (!wrap) return;
      var value = wrap.querySelector('[data-wrist-value]');
      var cards = root.querySelectorAll('[data-wrist-chips] [data-cm]');
      var out = wrap.querySelector('[data-wrist-out]');
      var sizeOut = wrap.querySelector('[data-wrist-size]');
      var fitOut = wrap.querySelector('[data-wrist-fit]');
      value.addEventListener('input', function () {
        var raw = value.value.trim().replace(',', '.');
        var w = parseFloat(raw);
        if (raw === '' || isNaN(w) || w < 10 || w > 24) {
          cards.forEach(function (c) { c.classList.remove('is-match'); });
          out.hidden = true;
          fitOut.hidden = true;
          return;
        }
        var lo = w + 1.5, hi = w + 2;
        cards.forEach(function (c) {
          var cm = parseFloat(c.getAttribute('data-cm'));
          c.classList.toggle('is-match', cm >= lo - 0.5 && cm <= hi + 0.5);
        });
        var min = lo.toFixed(1).replace('.0', '');
        var max = hi.toFixed(1).replace('.0', '');
        sizeOut.textContent = min + '–' + max + ' ' + (root.dataset.unitCm || 'cm');
        out.hidden = false;
        fitOut.textContent = (root.dataset.fitTpl || '').replace('{min}', min).replace('{max}', max);
        fitOut.hidden = false;
      });
    })();

    /* 5. Scrollspy + smooth nav */
    (function () {
      var nav = root.querySelector('[data-sg-nav]');
      var navLinks = nav ? nav.querySelectorAll('a') : [];
      var sections = root.querySelectorAll('[data-sg-section]');
      if ('IntersectionObserver' in window) {
        var spy = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              var id = e.target.getAttribute('id');
              navLinks.forEach(function (l) { l.classList.toggle('is-active', l.getAttribute('href') === '#' + id); });
            }
          });
        }, { rootMargin: '-45% 0px -50% 0px' });
        sections.forEach(function (sec) { spy.observe(sec); });
      }
      navLinks.forEach(function (l) {
        l.addEventListener('click', function (ev) {
          var target = root.querySelector(l.getAttribute('href'));
          if (target) { ev.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
        });
      });
    })();
  })();

  } catch(e) { console.error(e); }
})();
})();
